import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { FiTrash, FiEdit3 } from 'react-icons/fi'
import { Drawer, Row, Col, Input, Button } from 'antd'
import { motion } from 'framer-motion'

import { 
  Container, 
  ProductImage, 
  ProductInfo, 
  ProductName, 
  LicenseConfig, 
  ProductPrice, 
  RemoveButton,
  DrawerContent,
  ButtonsContainer
} from './styles'

import { removeProduct, addLicense, editLicense, removeLicense } from '../../store/actions/cart.actions'

function CartItem({ data: { id, name, licenses, image, price, promotional } }) {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)

  return (
    <React.Fragment>
      <Drawer
        title="Configurar Licenças"
        width={400}
        placement="right"
        closable={true}
        onClose={() => setVisible(false)}
        visible={visible}
        bodyStyle={{ padding: '20px' }}
      >
        <DrawerContent>
          <h4>Licença Principal</h4>
          <Row gutter={[16, 16]}>
            <Col span={16}>
              <Input
                size="large"
                placeholder="IP do servidor"
                value={licenses[0].ip}
                onChange={(e) => {
                  dispatch(
                    editLicense({
                      id,
                      idx: 0,
                      ip: e.target.value,
                      port: licenses[0].port,
                    })
                  )
                }}
              />
            </Col>
            <Col span={8}>
              <Input
                size="large"
                placeholder="Porta"
                value={licenses[0].port}
                onChange={(e) => {
                  var { value } = e.target
                  var reg = /^-?\d*(\.\d*)?$/
                  if ((!isNaN(value) && reg.test(value)) || value === '' || value === '-') {
                    dispatch(editLicense({ id, idx: 0, ip: licenses[0].ip, port: value }))
                  }
                }}
              />
            </Col>
          </Row>
          
          {licenses.length > 1 && (
            <>
              <h4>Licenças Adicionais</h4>
              {licenses.map((elem, idx) => {
                if (idx > 0) {
                  return (
                    <Row gutter={[16, 16]} key={`license-${idx}`} className="additional-license">
                      <Col span={14}>
                        <Input
                          size="large"
                          placeholder="IP do servidor"
                          value={elem.ip}
                          onChange={(e) => {
                            dispatch(editLicense({ id, idx, ip: e.target.value, port: elem.port }))
                          }}
                        />
                      </Col>
                      <Col span={6}>
                        <Input
                          size="large"
                          placeholder="Porta"
                          value={elem.port}
                          onChange={(e) => {
                            var { value } = e.target
                            var reg = /^-?\d*(\.\d*)?$/
                            if ((!isNaN(value) && reg.test(value)) || value === '' || value === '-') {
                              dispatch(editLicense({ id, idx, ip: elem.ip, port: value }))
                            }
                          }}
                        />
                      </Col>
                      <Col span={4}>
                        <Button
                          danger
                          size="large"
                          block
                          icon={<FiTrash />}
                          onClick={() => dispatch(removeLicense({ id, idx }))}
                        />
                      </Col>
                    </Row>
                  )
                }
                return null
              })}
            </>
          )}
          
          <div className="drawer-actions">
            <Button
              type="dashed"
              block
              onClick={() => dispatch(addLicense(id))}
              className="add-license-btn"
            >
              Adicionar licença (+R$5,00)
            </Button>
            
            <Button 
              type="primary" 
              block 
              onClick={() => setVisible(false)}
              className="save-btn"
            >
              Salvar Alterações
            </Button>
          </div>
        </DrawerContent>
      </Drawer>
      
      <Container
        as={motion.div}
        whileHover={{ y: -2 }}
      >
        <ProductImage>
          <img src={image} alt={`Atlas Plugins - ${name}`} />
        </ProductImage>
        
        <ProductInfo>
          <ProductName>{name}</ProductName>
        </ProductInfo>
        
        <ProductPrice>
          {promotional > 0 ? (
            <>
              <span className="old-price">R$ {parseFloat(price).toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}</span>
              <span className="current-price">R$ {parseFloat(promotional).toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}</span>
            </>
          ) : (
            <span className="current-price">R$ {parseFloat(price).toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}</span>
          )}
        </ProductPrice>
        
        <ButtonsContainer>
          <LicenseConfig 
            onClick={() => setVisible(true)} 
            title="Editar licenças"
            aria-label={`Editar ${licenses.length} ${licenses.length === 1 ? 'licença' : 'licenças'}`}
          >
             <span>{licenses.length} licença</span>
          </LicenseConfig>
          
          <RemoveButton
            onClick={() => dispatch(removeProduct(id))}
            aria-label="Remover item"
            title="Remover item"
            type="button"
          >
            <FiTrash />
          </RemoveButton>
        </ButtonsContainer>
      </Container>
    </React.Fragment>
  )
}

export default CartItem
